import { createPermission } from '@backstage/plugin-permission-common';

/** Must match backend `packages/backend/src/extensions/catalogAnnotations/permissions.ts`. */
export const catalogAnnotationsResolvePermission = createPermission({
  name: 'catalog-annotations.entity.resolve',
  attributes: { action: 'read' },
  resourceType: 'catalog-entity',
});

export const catalogAnnotationsApplyPermission = createPermission({
  name: 'catalog-annotations.entity.apply',
  attributes: { action: 'update' },
  resourceType: 'catalog-entity',
});
